import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pt-2 pl-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!

  return (_ctx.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_svg_icon, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.back())),
          class: "w-7 cursor-pointer",
          path: _ctx.mdiChevronLeft
        }, null, 8, ["path"])
      ]))
    : _createCommentVNode("", true)
}